import DM from 'DM';
import Hub from '../../hub.js';
import * as types from '../types.js';
import trackers from '@trackers';

export default {
    state: {
        avatarUrl: null,
        name: null,
        isAuthenticated: false,
        hashedEmail: null,
        hashedEmailSha256: null,
        email: null,
        gender: null,
    },
    mutations: {
        [types.USER_SET_DATA]: (state, payload) => {
            state = Object.assign(state, payload);
            // @TODO: cleanup, use store when posible
            DM.Config.userIsLoggedIn = payload.isAuthenticated;
            Hub.publish(Hub.USER_DATA_CHANGE, payload);
            Hub.publish(Hub.HTML_UPDATE, payload);

            if (payload.isAuthenticated) {
                window.addEventListener('firstInteraction', () => {
                    window.setTimeout(() => {
                        trackers.track('userLogged', payload);
                    }, 0);
                });
            }

            if (payload.hashedEmail) {
                DM.Utils.setCookie(DM.Cookies.UserEmail, payload.hashedEmail);
            }
            if (payload.hashedEmailSha256) {
                DM.Utils.setCookie(DM.Cookies.UserEmailSha256, payload.hashedEmailSha256);
            }
        }
    },
    actions: {
        [types.USER_FETCH_DATA]: ({ commit }, params) => (
            new Promise((resolve) => {
                DM.Service.User.getUser(params).then((data) => {
                    commit(types.USER_SET_DATA, data.user);
                    resolve(data);
                });
            })
        )
    }
};
